import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import { IconButton } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import MoreHorzIcon from "@material-ui/icons/MoreHoriz";
import { ORITATIONS } from "../constants/constants";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.paper
    }
  })
);

function SimpleListMenu(props: any) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedIndex] = React.useState(1);

  function handleClickListItem(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <div className={classes.root}>
      {props.oritation === ORITATIONS.VERTICAL && (
        <IconButton aria-label="settings" onClick={handleClickListItem}>
          <MoreVertIcon />
        </IconButton>
      )}
      {props.oritation === ORITATIONS.HORIZONTAL && (
        <IconButton aria-label="settings" onClick={handleClickListItem}>
          <MoreHorzIcon />
        </IconButton>
      )}
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {props.options.map((option: any, index: any) =>
          props.renderItem(option, index, selectedIndex, handleClose)
        )}
      </Menu>
    </div>
  );
}

export default SimpleListMenu;
